import React from 'react'
import type { KambiSportsEventDetails, KambiSportsSelection } from '@mobi/betslip/types'
import {
  KambiSportsHeaderSingle,
  KambiSportsHeaderMulti,
  KambiSportsHeaderSameGameMulti,
} from './Components'

export const KambiSportsHeader: React.FC<{
  selection: KambiSportsSelection
  eventDetails: KambiSportsEventDetails
}> = ({ selection, eventDetails }) => {
  if (selection.betSelectionType === 'single') {
    return <KambiSportsHeaderSingle selection={selection} eventDetails={eventDetails} />
  }

  if (selection.betSelectionType === 'multi') {
    return <KambiSportsHeaderMulti selection={selection} eventDetails={eventDetails} />
  }

  return <KambiSportsHeaderSameGameMulti selection={selection} eventDetails={eventDetails} />
}
